import { render, staticRenderFns } from "./ProductsRanking.vue?vue&type=template&id=f1baf1d8&scoped=true&lang=pug&"
import script from "./ProductsRanking.vue?vue&type=script&lang=js&"
export * from "./ProductsRanking.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRanking.vue?vue&type=style&index=0&id=f1baf1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1baf1d8",
  null
  
)

/* custom blocks */
import block0 from "./ProductsRanking.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VDivider,VSimpleTable,VTab,VTabs})
